import { render, staticRenderFns } from "./claim.vue?vue&type=template&id=4aed62a8&scoped=true"
import script from "./claim.vue?vue&type=script&lang=js"
export * from "./claim.vue?vue&type=script&lang=js"
import style0 from "./claim.vue?vue&type=style&index=0&id=4aed62a8&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aed62a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aed62a8')) {
      api.createRecord('4aed62a8', component.options)
    } else {
      api.reload('4aed62a8', component.options)
    }
    module.hot.accept("./claim.vue?vue&type=template&id=4aed62a8&scoped=true", function () {
      api.rerender('4aed62a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claimWorkOrder/claim.vue"
export default component.exports